/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_OciInputs */

const en_cargo_oci = /** @type {(inputs: Cargo_OciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo OCI`)
};

const es_cargo_oci = /** @type {(inputs: Cargo_OciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI de carga`)
};

/**
* | output |
* | --- |
* | "Cargo OCI" |
*
* @param {Cargo_OciInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_oci = /** @type {((inputs?: Cargo_OciInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_OciInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_oci(inputs)
	return es_cargo_oci(inputs)
});